export default __webpack_public_path__ + "static/media/icon-register.3feec450.svg";